import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { entitlementsTrackingSelector } from 'common/selectors/analyticsSelectors';
import BannerAd from 'common/ads/BannerAd';
import SearchResultsContainer from './search/SearchResultsContainer';
import MainContainer from './common/MainContainer';
import SearchContainer from 'common/search/SearchContainer';
import { PageType } from 'enums';
import { initAdsConfig } from 'common/ads/actions';
import { setPageInfo } from 'common/page/actions';

const bannerAd = [<BannerAd key="banner_ad" />];

const Search = ({ params: { searchTerm = '' }, entitlementsTracking }) => (
    <MainContainer pre={bannerAd}>
        <section className="layout-full">
            <SearchContainer entitlementsTracking={entitlementsTracking} pageType={PageType.SEARCH} enabled />
        </section>
        <section className="layout-bc layout-bc--watch">
            <SearchResultsContainer searchTerm={searchTerm} />
        </section>
    </MainContainer>
    );

Search.loadActions = [
    (params, query) => initAdsConfig('search', null, {}, query),
    () => setPageInfo('search', 'Search', false)
];

Search.propTypes = {
    params: PropTypes.object,
    entitlementsTracking: PropTypes.object
};

const mapStateToProps = (state) => ({
    entitlementsTracking: entitlementsTrackingSelector(state)
});

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./app/common/page/Search.js